//Built-in libraries
import type { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';

//Custom components
import Table from '../../../UI/Table';

//Services

//Assets and Miscellaneous

const YearRule = ({ data }: { data: any }) => {
  const [perPage, setPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, _setTotalPage] = useState<number>(1);

  const nextPageHandler = () => {
    setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
  };

  const previousPageHandler = () => {
    setPage((prevState) => (prevState > 1 ? page - 1 : 1));
  };

  const tableColumns: ColumnDef<any>[] = [
    {
      id: 'name',
      header: () => <div className='text-center w-64'>Name of Bond Bill</div>,
      accessorKey: 'name',
      cell: (props) => {
        const { getValue } = props;
        return getValue() as string;
      },
    },
    {
      id: 'district',
      header: () => <div className='text-center'>Legislative District </div>,
      accessorKey: 'district',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='text-center'>
            <span>{getValue() as string}</span>
          </div>
        );
      },
    },
    {
      id: 'totalGrants',
      header: () => <div className='text-center'>Grant Amount</div>,
      accessorKey: 'totalGrants',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='text-center'>
            <span>{getValue() as string}</span>
          </div>
        );
      },
    },
  ];

  const tablePagination = {
    page: page,
    pageSize: perPage,
    pageCount: totalPage,
    currentPage: page,
    setPageSize: (v: number) => setPerPage(v),
    nextPage: nextPageHandler,
    previousPage: previousPageHandler,
  };

  return (
    <div className='h-96 border rounded-b-md w-full'>
      <Table cols={tableColumns} tableData={data} pagination={tablePagination} />
    </div>
  );
};

export default YearRule;
